import 'rxjs/add/operator/do';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { LogoutAction, All, LoginAction, LOGOUT } from './appState/app.actions';
import { tap } from 'rxjs/operators';

export type MyAction = All;

@Injectable()
export class AppEffects {
  constructor(private actions$: Actions<All>, private router: Router ) {}

  @Effect({ dispatch: false }) logout$ = 
    this.actions$.pipe(
      ofType<LogoutAction>(LOGOUT),
      tap( action => {
        this.router.navigate(['/login']);
      }));
}


// WEBPACK FOOTER //
// ./src/app/app.effects.ts